import React, { memo, useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import {
	PageContainer,
	PageTitle,
} from '@audacious/components/components/Page';
import { Row, Column } from '@audacious/components/components/Grid';
import PatientDetails from './patient-details';
import CareTeams from './care-teams';
import './patient-summary-page.scss';

function PatientSummaryPage() {
	const { id: notificationId } = useParams();
	const history = useHistory();

	const handleBack = useCallback(() => history.push('/notifications'), [
		history,
	]);

	return (
		<>
			<PageTitle pageName="Patient Summary" onBack={handleBack} />
			<PageContainer>
				<Row gutter="32">
					<Column>
						<PatientDetails notificationId={notificationId} />
					</Column>
					<Column>
						<CareTeams notificationId={notificationId} />
					</Column>
				</Row>
			</PageContainer>
		</>
	);
}

export default memo(PatientSummaryPage);
